import { createContext } from 'react';
export const LineaBaseContext = createContext();
